/**
 * مضاعفات حجم العمل — قيم افتراضية عند عدم وجود صف في قاعدة البيانات
 * الجدول: pricing_workload_multipliers (يُحمّل عبر pricingService.getPricingConfig)
 */
export const WORKLOAD_MULTIPLIERS = {
  one_item: 1.0,
  small: 1.4,
  medium: 1.9,
  large: 2.7,
  xlarge: 3.15,
  wedding_event_only: 1.4,
  wedding_prep_and_event: 1.9,
  wedding_full_coverage: 2.7,
  portrait_one: 1.4,
  portrait_two: 1.9,
  portrait_group: 2.7,
};

/** حجم المنتج الفعلي — افتراضيات عند غياب DB */
export const PRODUCT_PHYSICAL_SIZE_MULTIPLIERS = {
  compact: 1.0,
  standard: 1.12,
  bulky: 1.28,
};

/**
 * @param {string} workloadBucket
 * @param {Record<string, number>|null|undefined} dbMap - من pricing_workload_multipliers (kind=workload)
 */
export function resolveWorkloadMultiplier(workloadBucket, dbMap) {
  if (!workloadBucket) return 1.0;
  const fromDb = dbMap?.[workloadBucket];
  if (typeof fromDb === 'number' && fromDb > 0) return fromDb;
  return WORKLOAD_MULTIPLIERS[workloadBucket] ?? 1.0;
}

/**
 * @param {string} sizeBucket
 * @param {Record<string, number>|null|undefined} dbMap - من pricing_workload_multipliers (kind=product_physical)
 */
export function resolveProductPhysicalSizeMultiplier(sizeBucket, dbMap) {
  if (!sizeBucket) return 1.0;
  const fromDb = dbMap?.[sizeBucket];
  if (typeof fromDb === 'number' && fromDb > 0) return fromDb;
  return PRODUCT_PHYSICAL_SIZE_MULTIPLIERS[sizeBucket] ?? 1.0;
}

/**
 * مضاعف حجم العمل الفعّال (يشمل حجم المنتج لنوع product)
 * @param {object} [maps] - { workloadByBucket?, productPhysicalByBucket? }
 */
export function resolveEffectiveWorkloadMultiplier(
  photographyType,
  workloadBucket,
  productPhysicalSizeBucket,
  maps = {}
) {
  const { workloadByBucket, productPhysicalByBucket } = maps;
  const base = resolveWorkloadMultiplier(workloadBucket, workloadByBucket);
  if (photographyType !== 'product' || !productPhysicalSizeBucket) {
    return base;
  }
  const sizeMult = resolveProductPhysicalSizeMultiplier(productPhysicalSizeBucket, productPhysicalByBucket);
  return base * sizeMult;
}
